import styled from 'styled-components'
import { tokens, Button } from '@arvoreeducacao/bonsai-ds'

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: auto;
  display: flex;
  margin-bottom: 30px;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    flex-direction: row-reverse;
    margin-top: auto;
    margin-bottom: 130px;
  }
`

export const CustomButton = styled(Button)`
  width: 90%;
  margin: 8px 0;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: auto;
    margin-left: 16px;
  }
`
